import React from "react";
import AllowedAccess from "../../guards/AllowedAccess";
import PermissionList from "../../guards/PermissionList";

export const PermissionButton = ({ label, enabled, setEnabled, disabled }) => {
  console.log('PermissionButton label', label)
  return (
    <div
      className={`flex items-center justify-between p-[5px] pl-[30px] w-full rounded-md ${disabled ? "opacity-50 cursor-not-allowed" : ""
        }`}
    >
      <div className="flex items-center space-x-2">
        <span className={`text-[14px] ${disabled ? "text-gray-400" : "text-[#373737]"}`}>
          {label}
        </span>
      </div>
      <AllowedAccess permissions={[PermissionList.admin_userAccess.edit_permissions]}
        mode="readonly"
      >


        <label className="relative inline-flex items-center cursor-pointer">
          <input
            type="checkbox"
            checked={enabled}
            onChange={() => !disabled && setEnabled()} // Only allow toggle if not disabled
            className="sr-only peer"
            disabled={disabled} // native disabled for accessibility
          />
          <div
            className={`w-[38px] h-[20px] rounded-full transition-colors duration-300 ${enabled ? "bg-[#245CEA]" : "bg-white border border-[#87909E]"
              } ${disabled ? "opacity-50" : ""}`}
          >
            <div
              className={`absolute top-[2px] left-[2px] h-[16px] w-[16px] rounded-full transition-transform duration-300 ${enabled ? "translate-x-[18px] bg-white" : "translate-x-0 bg-[#87909E]"
                }`}
            />
          </div>
        </label>
      </AllowedAccess>
    </div>
  );
};
